// extracted by mini-css-extract-plugin
export default {"grayscale":"T4zkfs","clickable":"wWlft2","card":"BleHYI","activeCard":"K6EK0E"};